module.exports = __webpack_public_path__ + "static/img/titulo_mixroedores_mobile.ffd47fc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/categories/banners/titulo_mixroedores_mobile.jpg
// module id = 8lRM
// module chunks = 0